import React, { useState, useEffect, useCallback } from 'react'
import {
    Autocomplete,
    Button,
    MenuItem,
    Select,
    TextField,
} from '@mui/material'
import { Container, Header, Form } from './styles'
import api, { operation } from '../../services/axios'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import swal from 'sweetalert'
import { get } from 'lodash'
import { useForm, Controller, SubmitHandler } from 'react-hook-form'
import Loading from '../../components/Loading'
import { useBancos } from '../../hooks/bancos'

// validar email async
// const schema = yup.object().shape({
//     cnpj_cpf: yup.string().required(),
//     fantasy_name: yup.string().required().min(3).max(255),
//     invoicing: yup.string(),
//     address: yup.string().required().min(3).max(64),
//     city: yup.string().required().min(3).max(64),
//     complement: yup.string().min(0).max(64),
//     district: yup.string().required().min(3).max(64),
//     number: yup.string().required(),
//     email: yup.string().required().email(),
//     fone: yup.string().required().min(11).max(11),
//     zipcode: yup.string().required().min(8).max(8),
//     type: yup.string().required().min(3).max(64),
//     state: yup.string().required(),
// })

interface Inputs {
    agencia: string
    tipoConta: string
    compe: string
    numeroConta: string
}

const DomicilioPagamento: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const [valueBanco, setValueBanco] = useState(['', ''])
    const [numeroConta, setNumeroConta] = useState('')
    const { bancos, getIspb } = useBancos()
    const [isLoading, setIsLoading] = useState(false)

    const {
        control,
        formState: { errors },
        handleSubmit,
        setValue,
    } = useForm<Inputs>()
    // const [institution, setInstitution] = useState('')

    const getInstitutionData = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                const { data } = await api.get(
                    `/institution/domicilio-pagamento/${cnpj_cpf}`
                )
                setValue('agencia', data.agencia)
                setValue('tipoConta', data.tipoConta)
                const compe = data.compe
                const banco = bancos[compe] || ''
                setValueBanco((prev) => [compe, banco])
                setValue('compe', data.compe)
                setNumeroConta((prev) => data.numeroConta)
                setValue('numeroConta', data.numeroConta)
                setIsLoading(false)
            } catch (e: any) {
                // toast.error(erro)
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf, setValue, bancos])

    useEffect(() => {
        getInstitutionData()
    }, [getInstitutionData])

    const submit: SubmitHandler<Inputs> = async (inputs) => {
        const domicilioPagamentoData = {
            cnpj_cpf,
            agencia: inputs.agencia,
            compe: inputs.compe,
            ispb: getIspb(inputs.compe),
            tipoConta: inputs.tipoConta,
            numeroConta: numeroConta,
        }

        try {
            await api.post(
                `/institution/domicilio-pagamento`,
                domicilioPagamentoData
            )
            swal({
                title: 'Sucesso!',
                text: `Seu dados foram atualizados`,
                icon: 'success',
            })
        } catch (error) {
            swal({
                title: 'Erro!',
                text: `Não foi possível atualizar seus dados`,
                icon: 'error',
            })
        }
    }

    function handleChange(
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        if (e.target.name === 'numeroConta') {
            let value = e.target.value
            value = value.replace(/\D/g, '')
            const array = value.split('')
            const ultimoDigito = array.pop()
            const contaSemDigito = array.join('')
            let conta = ultimoDigito
            if (array.length >= 1) {
                conta = `${contaSemDigito}-${ultimoDigito}`
            }
            e.target.value = conta || ''
            setNumeroConta(e.target.value)
        }
    }

    return (
        <Container>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <Header>
                        <div className="title">
                            <h2>Domicílio de pagamento</h2>
                            <p>Atualize os dados bancários da sua empresa</p>
                        </div>
                        <div className="actions">
                            <Button
                                type="submit"
                                form="form-pag"
                                variant="contained"
                            >
                                Salvar
                            </Button>
                        </div>
                    </Header>

                    <Form id="form-pag" onSubmit={handleSubmit(submit)}>
                        <fieldset className="fieldset">
                            <div className="input-group">
                                <div className="input-wrapper">
                                    {/* <TextField type='text' className='input' label='Cnpj ou Cpf' name='cnpj_cpf' disabled onChange={(e) => handleChange(e)} value={cnpjCpfMask(institution?.cnpj_cpf || '')} id="cnpj_cpf" variant="outlined" /> */}
                                    <Controller
                                        defaultValue=""
                                        name="compe"
                                        control={control}
                                        rules={{
                                            required:
                                                'O campo banco é obrigatório',
                                        }}
                                        render={({ field }) => (
                                            <Autocomplete
                                                onChange={(event, newValue) => {
                                                    const value: string =
                                                        newValue
                                                            ? newValue[0]
                                                            : ''

                                                    setValueBanco(
                                                        newValue || ['', '']
                                                    )

                                                    field.onChange(value)
                                                }}
                                                onInputChange={(
                                                    event,
                                                    value
                                                ) => {
                                                    // const { data } = await api.get(`/comissao/taxa/${cnpj_cpf}`)
                                                    // if(value === '') setSelectedFav({})
                                                    const compe = value
                                                        .split('-')[0]
                                                        .trim()

                                                    field.onChange(compe)
                                                }}
                                                getOptionLabel={(option) => {
                                                    return option[1]
                                                }}
                                                isOptionEqualToValue={(
                                                    option,
                                                    value
                                                ) => {
                                                    return (
                                                        option[0] === value[0]
                                                    )
                                                }}
                                                disablePortal
                                                value={valueBanco}
                                                id="compe"
                                                options={Object.entries(bancos)}
                                                sx={{
                                                    width: '100%',
                                                    fontFamily: 'Roboto',
                                                    fontSize: '18px',
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label=""
                                                        placeholder="Banco"
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.compe &&
                                        errors.compe.type === 'required' && (
                                            <span className="hook-error">
                                                {errors.compe.message}
                                            </span>
                                        )}
                                </div>
                            </div>
                            <div className="input-group">
                                <div className="input-wrapper">
                                    <Controller
                                        defaultValue=""
                                        name="agencia"
                                        control={control}
                                        rules={{
                                            required:
                                                'O campo agência é obrigatório',
                                            minLength: 3,
                                            maxLength: 100,
                                        }}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className="input"
                                                id="agencia"
                                                placeholder="Agência"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                    {errors.agencia &&
                                        errors.agencia.type === 'required' && (
                                            <span className="hook-error">
                                                {errors.agencia.message}
                                            </span>
                                        )}
                                    {/* <TextField className='input' name='fantasy_name' label='Nome fantansia' onChange={(e) => handleChange(e)} value={institution?.fantasy_name} id="fantasy_name" variant="outlined" /> */}
                                </div>
                                <div className="input-wrapper">
                                    <Controller
                                        defaultValue=""
                                        name="numeroConta"
                                        control={control}
                                        rules={{
                                            required:
                                                'O campo número da conta é obrigatório',
                                            onChange: (e) => handleChange(e),
                                        }}
                                        render={({
                                            field: { value, ...field },
                                        }) => (
                                            <TextField
                                                {...field}
                                                value={numeroConta}
                                                onChange={(e) =>
                                                    field.onChange(e)
                                                }
                                                className="input"
                                                id="numeroConta"
                                                placeholder="Número da conta"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                    {errors.numeroConta &&
                                        errors.numeroConta.type ===
                                            'required' && (
                                            <span className="hook-error">
                                                {errors.numeroConta.message}
                                            </span>
                                        )}
                                </div>
                            </div>

                            <div className="input-group">
                                <div className="input-wrapper">
                                    <Controller
                                        defaultValue="null"
                                        name="tipoConta"
                                        control={control}
                                        rules={{
                                            required:
                                                'Selecione o tipo da conta',
                                            validate: (tipo: string) =>
                                                !(tipo === 'null'),
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                sx={{ width: '100%' }}
                                                labelId="tipoConta-label"
                                                id="tipoConta-select"
                                                placeholder="Tipo de conta"
                                            >
                                                <MenuItem disabled value="null">
                                                    Selecionar tipo de conta
                                                </MenuItem>
                                                <MenuItem value="CC">
                                                    CC - Conta Corrente
                                                </MenuItem>
                                                {/* <MenuItem value='CD'>CD - Conta de Depósito</MenuItem> */}
                                                {/* <MenuItem value='CG'>CG - Conta Garantia</MenuItem> */}
                                                {/* <MenuItem value='CI'>CI - Conta Investimento</MenuItem> */}
                                                {/* <MenuItem value='CP'>CP - Conta de Pagamento</MenuItem> */}
                                                <MenuItem value="PP">
                                                    PP - Conta Poupança
                                                </MenuItem>
                                            </Select>
                                        )}
                                    />
                                    {errors.tipoConta &&
                                        errors.tipoConta.type ===
                                            'validate' && (
                                            <span className="hook-error">
                                                Selecione o tipo da conta
                                            </span>
                                        )}
                                </div>
                            </div>
                        </fieldset>
                    </Form>
                </>
            )}
        </Container>
    )
}

export default DomicilioPagamento
